import ElementUI from 'element-ui';
import lang from 'element-ui/lib/locale/lang/en';
import locale from 'element-ui/lib/locale';

import TheSourceBadge from './TheSourceBadge.vue';
import TheSourceButton from './TheSourceButton.vue';
import TheSourceCheckbox from './TheSourceCheckbox.vue';
import TheSourceCollapse from './TheSourceCollapse.vue';
import TheSourceDatePicker from './TheSourceDatePicker.vue';
import TheSourceDialog from './TheSourceDialog.vue';
import TheSourceDivider from './TheSourceDivider.vue';
import TheSourceDropdown from './TheSourceDropdown.vue';
import TheSourceExpansionPanel from './TheSourceExpansionPanel.vue';
import TheSourceFormItem from './TheSourceFormItem.vue';
import TheSourceFormSection from './TheSourceFormSection.vue';
import TheSourceIcon from './TheSourceIcon.vue';
import TheSourceInput from './TheSourceInput.vue';
import TheSourceInputNumber from './TheSourceInputNumber.vue';
import TheSourceLargeSteps from './TheSourceLargeSteps.vue';
import TheSourceLink from './TheSourceLink.vue';
import TheSourceLoader from './TheSourceLoader.vue';
import TheSourceMenu from './TheSourceMenu.vue';
import TheSourceMenuGroup from './TheSourceMenuGroup.vue';
import TheSourceMenuItem from './TheSourceMenuItem.vue';
import TheSourceMenuSubItem from './TheSourceMenuSubItem.vue';
import TheSourceMetric from './TheSourceMetric.vue';
import TheSourcePage from './TheSourcePage.vue';
import TheSourcePagination from './TheSourcePagination.vue';
import TheSourcePagination2 from './TheSourcePagination2.vue';
import TheSourcePagination2Page from './TheSourcePagination2Page.vue';
import TheSourcePanel from './TheSourcePanel.vue';
import TheSourcePopover from './TheSourcePopover.vue';
import TheSourceProgress from './TheSourceProgress.vue';
import TheSourceRadio from './TheSourceRadio.vue';
import TheSourceSearchBar from './TheSourceSearchBar.vue';
import TheSourceSelect from './TheSourceSelect.vue';
import TheSourceSlider from './TheSourceSlider.vue';
import TheSourceSlider2 from './TheSourceSlider2.vue';
import TheSourceSorter from './TheSourceSorter.vue';
import TheSourceSteps from './TheSourceSteps.vue';
import TheSourceSwitch from './TheSourceSwitch.vue';
import TheSourceTag from './TheSourceTag.vue';
import TheSourceToolbar from './TheSourceToolbar.vue';
import TheSourceUpload from './TheSourceUpload.vue';
import TheSourceWell from './TheSourceWell.vue';
import TheSourceRating from './TheSourceRating.vue';

const components = [
  TheSourceBadge,
  TheSourceButton,
  TheSourceCheckbox,
  TheSourceCollapse,
  TheSourceDatePicker,
  TheSourceDialog,
  TheSourceDivider,
  TheSourceDropdown,
  TheSourceExpansionPanel,
  TheSourceFormItem,
  TheSourceFormSection,
  TheSourceIcon,
  TheSourceInput,
  TheSourceInputNumber,
  TheSourceLargeSteps,
  TheSourceLink,
  TheSourceLoader,
  TheSourceMenu,
  TheSourceMenuGroup,
  TheSourceMenuItem,
  TheSourceMenuSubItem,
  TheSourceMetric,
  TheSourcePage,
  TheSourcePagination,
  TheSourcePagination2,
  TheSourcePagination2Page,
  TheSourcePanel,
  TheSourcePopover,
  TheSourceProgress,
  TheSourceRadio,
  TheSourceSearchBar,
  TheSourceSelect,
  TheSourceSlider,
  TheSourceSlider2,
  TheSourceSorter,
  TheSourceSteps,
  TheSourceSwitch,
  TheSourceTag,
  TheSourceToolbar,
  TheSourceUpload,
  TheSourceWell,
  TheSourceRating
];

function install(Vue) {
  components.forEach(component => {
    Vue.component(component.name, component);
  });
  locale.use(lang);

  Vue.use(ElementUI);
}

export default {
  install
};
